import React from 'react';
import PropTypes from 'prop-types';

const ProgressBar = ({ value, max, label }) => {
  const percent = max > 0 ? Math.min((value / max) * 100, 100) : 0;

  return (
    <div className="o-progress-bar">
      <div className="o-progress-bar__container">
        <div className="o-progress-bar__fill" style={{ width: `${percent}%` }} />
      </div>
      {label && <div className="o-progress-bar__label">{label}</div>}
    </div>
  );
};

ProgressBar.propTypes = {
  value: PropTypes.number.isRequired,
  max: PropTypes.number.isRequired,
  label: PropTypes.string,
};

export default ProgressBar;
